import NavFooter from './NavFooter';

export default NavFooter;


// WEBPACK FOOTER //
// ./src/components/NavFooter/index.js